import { Fragment } from "react";
import {
  Group,
  Avatar,
  Text,
  Accordion,
  Badge,
  Center,
  Indicator,
  Space,
  Stack,
  Flex,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconCrown } from "@tabler/icons-react";

import Translate from "Components/Translate";
import { ACTIVE, DISABLED } from "Constant";
import ListOfData from "./ListOfData";

function UsersComp({ data, updateBtn, client_code }) {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  const accordion = data.map((elem, i) => {
    const { image } = elem;
    const id = i.toString();

    const title = (
      <Text fw={700} size={isSmallScreen ? "sm" : "md"}>
        {elem.usr_owner ? (
          <Badge
            variant="gradient"
            gradient={{ from: "yellow", to: "orange", deg: 90 }}
            leftSection={elem.usr_owner ? <IconCrown size={14} /> : null}
          >
            {elem.full_name}
          </Badge>
        ) : (
          <Badge variant="gradient">{elem.full_name}</Badge>
        )}
      </Text>
    );

    const currentState = (
      <Badge color={elem.online ? "teal" : "red"}>
        {elem.online ? "En ligne" : "Hors ligne"}
      </Badge>
    );

    const indicatorProps = elem.user_active
      ? { color: "green", label: <Translate>{ACTIVE}</Translate> }
      : { color: "red", label: <Translate>{DISABLED}</Translate> };

    return (
      <Accordion.Item value={id} key={id}>
        <Accordion.Control>
          <Flex
            direction={isSmallScreen ? "column" : "row"}
            align="center"
            justify="space-between"
            wrap="nowrap"
            style={{ width: "100%" }} // Prevents unnecessary stacking on large screens
          >
            <Indicator
              inline
              label={indicatorProps.label}
              color={indicatorProps.color}
            >
              {image ? (
                <Avatar
                  src={image}
                  radius="xl"
                  size={isSmallScreen ? "md" : "lg"}
                />
              ) : (
                <Avatar
                  radius="xl"
                  size={isSmallScreen ? "md" : "lg"}
                  color="orange"
                />
              )}
            </Indicator>

            <Flex
              direction={isSmallScreen ? "column" : "row"}
              align="center"
              justify={isSmallScreen ? "center" : "space-between"}
              style={{ width: "100%" }} // Ensures proper alignment
              gap="xs"
            >
              {title}
              {currentState}
            </Flex>
          </Flex>
        </Accordion.Control>

        <Accordion.Panel>
          <ListOfData driverDetails={elem} client_code={client_code} />
        </Accordion.Panel>
      </Accordion.Item>
    );
  });

  return (
    <Fragment>
      <Space h="md" />
      <Accordion chevronPosition="left" variant="contained">
        {accordion}
      </Accordion>
    </Fragment>
  );
}

export default UsersComp;
